import { SVGProps } from 'react';

export type AddCircleIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const AddCircleIcon = ({ color = '#090807', ...props }: AddCircleIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0001 1.66602C5.40008 1.66602 1.66675 5.39935 1.66675 9.99935C1.66675 14.5993 5.40008 18.3327 10.0001 18.3327C14.6001 18.3327 18.3334 14.5993 18.3334 9.99935C18.3334 5.39935 14.6001 1.66602 10.0001 1.66602ZM14.1667 10.8327H10.8334V14.166H9.16675V10.8327H5.83342V9.16602H9.16675V5.83268H10.8334V9.16602H14.1667V10.8327Z"
      fill={color}
    />
  </svg>
);
